// extracted by mini-css-extract-plugin
export default {"wrapper":"DHckB1B2AgIF9Bv8QgYs"};